<template>
  <AutoComplete
    v-model="selectedReward"
    option-label="name"
    :suggestions="filteredRewards"
    dropdown
    force-selection
    style="z-index: 1500"
    @complete="search"
    @item-select="selectReward"
    @clear="unselectReward"
  />
</template>

<script setup lang="ts">
import AutoComplete, { AutoCompleteCompleteEvent, AutoCompleteItemSelectEvent } from "primevue/autocomplete";
import { onMounted, ref, watch } from "vue";

import { useGetRewardsQuery } from "@/graphql";
import { Reward } from "@/modules/Rewards/types";

const emit = defineEmits(["select-reward"]);

const props = defineProps<{
  gameId: string;
  versionId: string;
  modelValue: Reward | null | undefined;
}>();

const selectedReward = ref(props.modelValue);
const filteredRewards = ref();
const rewards = ref<Reward[]>();

const { refetch: refetchRewards } = useGetRewardsQuery({
  appId: props.gameId,
  versionId: props.versionId,
});

const selectReward = (reward: AutoCompleteItemSelectEvent) => {
  selectedReward.value = reward.value;
  emit("select-reward", reward.value);
};

const unselectReward = () => {
  selectedReward.value = null;
  emit("select-reward", null);
};

const search = (event: AutoCompleteCompleteEvent) => {
  setTimeout(() => {
    if (!rewards.value) {
      return;
    }
    if (!event.query.trim().length) {
      filteredRewards.value = [...rewards.value];
    } else {
      filteredRewards.value = rewards.value?.filter((reward) =>
        reward.name.toLowerCase().startsWith(event.query.toLowerCase())
      );
    }
  }, 250);
};

onMounted(async () => {
  const list = await refetchRewards();
  rewards.value = list?.data.getRewards as Reward[];
});

watch(
  () => props.modelValue,
  (newValue) => {
    selectedReward.value = newValue;
  },
  {
    immediate: true,
  }
);
</script>

<style module lang="scss">
.tooltip {
  margin-left: 0.5rem;
  color: var(--vd-color-yellow-500);
}
</style>
